module.exports = __webpack_public_path__ + "img/canvas-bg7.c47a34c8.png";